module.exports = __webpack_public_path__ + "media/personas/bg-information-fa003c36.jpg";